import { Col, Row, Carousel as BSCarousel } from "react-bootstrap";
import { chunk } from "lodash";
import clsx from "classnames";
import classes from "./styles.module.scss";

/**
 *
 * @param id
 * @param className
 * @param items
 * @param visibleCount
 * @param indicators
 * @param controls
 * @param fade
 * @returns {JSX.Element}
 * @constructor
 */
export const Carousel = ({ id, className, items, visibleCount, indicators, controls, fade }) => {
  return (
    <BSCarousel
      id={id}
      fade={fade}
      defaultActiveIndex={0}
      indicators={indicators && items.length > visibleCount}
      controls={controls && items.length > visibleCount}
      className={clsx(className, classes.carousel, "py-4 py-md-5")}
      pause={false}
    >
      {chunk(items, visibleCount).map((items, k) => (
        <BSCarousel.Item key={k}>
          <Row className="mx-0 py-3">
            {items.map((item, k) => (
              <Col style={{ width: `${Math.ceil(100 / visibleCount)}%` }} key={k}>
                {item}
              </Col>
            ))}
          </Row>
        </BSCarousel.Item>
      ))}
    </BSCarousel>
  );
};

Carousel.defaultProps = {
  visibleCount: 1,
  indicators: true,
  controls: false,
  fade: false,
};
